import {
  AddPage,
  EditPage,
  TablePage,
  ViewPage,
} from 'src/views/logisticsadmin/sequence'

import pathMap from 'src/paths/PathMap_LogisticsAdmin'

class SequenceRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.SEQUENCE_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.SEQUENCE_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.SEQUENCE_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.SEQUENCE_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default SequenceRoute
